// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const BxRecommenderLink = function(bxService: any, translationService: any, relatedItems: any) {
   return {
      replace: true,
      templateUrl: '/assets/bxRecommenderToggle.html',
      link(scope: any) {
         scope.bxRetrievedDocuments = bxService.retrievedDocuments
         scope.imActive = bxService.imActive
         if (!scope.i18n) { scope.i18n = translationService }

         return scope.toggleBxRecommendations = function() {
            if (bxService.toggleRecommendations.apply(bxService, arguments)) {
               bxService.bxStyle.md.top = angular.element(".header").offset()?.top + 'px'
               return relatedItems.reset()
            }
         }.bind(this)
      }
   }
}

const BxRecommender = (bxService: any) => ({
   templateUrl: '/assets/bxRecommender.html',
   controller: 'BxRecommenderCtrl',

   link(scope: any, elm: any, attrs: any){
      scope.imActive = bxService.imActive
      return scope.behavior = attrs.bxBehavior || 'md'
   }
})

angular.module('summonApp.directives')
   .directive('bxRecommenderLink', ['bxRecommenderService','translationService', 'relatedItemsService', BxRecommenderLink])
   .directive('bxRecommender', ['bxRecommenderService', BxRecommender])
